import Box from '@mui/material/Box';
import Pagination, { paginationClasses } from '@mui/material/Pagination';
import { PostItemSkeleton } from './post-skeleton';
import { PostItemHorizontal } from './post-item-horizontal';

export function PostListHorizontal({
  posts,
  loading,
  isSuperAdmin,
  onEdit,
  onDelete,
  tags,
  categories,
  page,
  totalPages,
  onPageChange,
  unwatchedVideos,
  ...other
}) {
  const renderLoading = () => <PostItemSkeleton variant="horizontal" />;

  const unwatchedArray = unwatchedVideos?.map((item) => item._id) || [];

  const renderList = () =>
    posts.map((post) => (
      <PostItemHorizontal
        key={post._id}
        post={post}
        isSuperAdmin={isSuperAdmin}
        onEdit={onEdit}
        onDelete={onDelete}
        tags={tags}
        categories={categories}
        other={other}
        newVideo={unwatchedArray?.includes(post._id)}
      />
    ));

  const handlePageChange = (event, newPage) => {
    onPageChange(newPage);
  };

  return (
    <>
      <Box
        sx={{
          gap: 3,
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: `repeat(${other.other.forHint ? '1' : '3'}, 1fr)` },
          maxWidth: '100%',
        }}
      >
        {loading ? renderLoading() : renderList()}
      </Box>

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          sx={{
            mt: { xs: 5, md: 8 },
            [`& .${paginationClasses.ul}`]: { justifyContent: 'center' },
          }}
        />
      )}
    </>
  );
}
